export default __webpack_public_path__ + "static/media/2.ea101c32.gif";